import React from 'react';
import { withRouter } from "react-router-dom";
import { withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { notification } from 'antd';
import DocumentMeta from 'react-document-meta';
import Header from '../Layout/Header.js';
import Footer from '../Layout/Footer.js';
import {sendContactUsAction} from '../../../actions/ContactUs.js';
import ReCAPTCHA from "react-google-recaptcha";
import '../../../index.css';


let classCaptcha="nonrequired";
class ContactUs extends  React.Component<any, any>  {
    constructor(props){
      super(props);      
      this.state = {
          header: "",
          formData:{},
          contaCtus:true,
          captcha:false         
      };     
    }

    componentWillReceiveProps(nextProps){
      if(nextProps&&nextProps.contactUsResponse&&nextProps.contactUsResponse.statusCode===200){
            notification.success({
                message:"Contact Request Send Successfully",
                className:'successNotification',
                duration: 3
            });
            this.setState({
                formData:{},
                contaCtus:false
            })
      }
    }

    onChange = (value) => {
     if(value){
        classCaptcha="nonrequired";
        this.setState({
          captcha:true
        })
     }else{
      this.setState({
          captcha:false
      })
     }
    }

    inputchange=(e)=>{
      e.preventDefault();
      const {formData}=this.state 
      formData[e.target.name]=e.target.value;
      console.log("e.target.name", e.target.name);
      console.log("e.target.value", e.target.value);
      this.setState({
        formData:formData
      })
    }

   
    contactUs=(e)=>{
      e.preventDefault();
      if(this.state.captcha){
          this.props.sendContactUsAction(this.state.formData)
      }else{
        classCaptcha="require";
        this.setState({
          classCaptcha:"require"
        })
      }

      
    }


    render() {
      const meta = {
        title: 'Right Connection - Contact Us',
        description: 'Contact with Right Connection on 8584720661 or Email on admin@arightconnection.com. Address - 3343, Keystone Ave, Suite 7, Los Angeles, CA - 90034.',
        canonical: '<link rel="canonical" href=" https://arightconnection.com/ " data-rdm="">',
        meta: {
          charset: 'utf-8',
          name: {
            keywords: 'Information Technology Recruiter Los Angeles, Information Technology Recruitment Services Los Angeles, Technical Recruiter Los Angeles, Technical Recruitment Services Los Angeles, Product Management Recruiter Los Angeles, Product Management Recruitment Services Los Angeles, C-Level Recruiter Los Angeles, C-Level Recruitment Services Los Angeles, Leadership Recruiters Los Angeles, Leadership Recruitment Services Los Angeles, Accounting Recruiter Los Angeles, Accounting Recruitment Services Los Angeles, Finance Recruiter Los Angeles, Finance Recruitment Services Los Angeles, Accounting & Finance Recruiter Los Angeles, Accounting & Finance Recruitment Services Los Angeles, Sales & Marketing Recruiter Los Angeles, Sales & Marketing Recruitment Services Los Angeles, Marketing Recruiter Los Angeles, Marketing Recruitment Services Los Angeles, Sales Recruitment Los Angeles, Sales Recruitment Services Los Angeles, Career Coaching Services Los Angeles, Creatives Recruiter Los Angeles, Creatives Recruitment Services Los Angeles, , Information Technology Recruiter New York, Information Technology Recruitment Services New York, Technical Recruiter New York, Technical Recruitment Services New York, Product Management Recruiter New York, Product Management Recruitment Services New York, C-Level Recruiter New York, C-Level Recruitment Services New York, Leadership Recruiters New York, Leadership Recruitment Services New York, Accounting Recruiter New York, Accounting Recruitment Services New York, Finance Recruiter New York, Finance Recruitment Services New York, Accounting & Finance Recruiter New York, Accounting & Finance Recruitment Services New York, Sales & Marketing Recruiter New York, Sales & Marketing Recruitment Services New York, Marketing Recruiter New York, Marketing Recruitment Services New York, Sales Recruitment New York, Sales Recruitment Services New York, Career Coaching Services New York, Creatives Recruiter New York, Creatives Recruitment Services New York, , , Information Technology Recruiter Seattle, Information Technology Recruitment Services Seattle, Technical Recruiter Seattle, Technical Recruitment Services Seattle, Product Management Recruiter Seattle, Product Management Recruitment Services Seattle, C-Level Recruiter Seattle, C-Level Recruitment Services Seattle, Leadership Recruiters Seattle, Leadership Recruitment Services Seattle, Accounting Recruiter Seattle, Accounting Recruitment Services Seattle, Finance Recruiter Seattle, Finance Recruitment Services Seattle, Accounting & Finance Recruiter Seattle, Accounting & Finance Recruitment Services Seattle, Sales & Marketing Recruiter Seattle, Sales & Marketing Recruitment Services Seattle, Marketing Recruiter Seattle, Marketing Recruitment Services Seattle, Sales Recruitment Seattle, Sales Recruitment Services Seattle, Career Coaching Services Seattle, Creatives Recruiter Seattle, Creatives Recruitment Services Seattle, , Information Technology Recruiter Portland, Information Technology Recruitment Services Portland, Technical Recruiter Portland, Technical Recruitment Services Portland, Product Management Recruiter Portland, Product Management Recruitment Services Portland, C-Level Recruiter Portland, C-Level Recruitment Services Portland, Leadership Recruiters Portland, Leadership Recruitment Services Portland, Accounting Recruiter Portland, Accounting Recruitment Services Portland, Finance Recruiter Portland, Finance Recruitment Services Portland, Accounting & Finance Recruiter Portland, Accounting & Finance Recruitment Services Portland, Sales & Marketing Recruiter Portland, Sales & Marketing Recruitment Services Portland, Marketing Recruiter Portland, Marketing Recruitment Services Portland, Sales Recruitment Portland, Sales Recruitment Services Portland, Career Coaching Services Portland, Creatives Recruiter Portland, Creatives Recruitment Services Portland, , Information Technology Recruiter San Diego, Information Technology Recruitment Services San Diego, Technical Recruiter San Diego, Technical Recruitment Services San Diego, Product Management Recruiter San Diego, Product Management Recruitment Services San Diego, C-Level Recruiter San Diego, C-Level Recruitment Services San Diego, Leadership Recruiters San Diego, Leadership Recruitment Services San Diego, Accounting Recruiter San Diego, Accounting Recruitment Services San Diego, Finance Recruiter San Diego, Finance Recruitment Services San Diego, Accounting & Finance Recruiter San Diego, Accounting & Finance Recruitment Services San Diego, Sales & Marketing Recruiter San Diego, Sales & Marketing Recruitment Services San Diego, Marketing Recruiter San Diego, Marketing Recruitment Services San Diego, Sales Recruitment San Diego, Sales Recruitment Services San Diego, Career Coaching Services San Diego, Creatives Recruiter San Diego, Creatives Recruitment Services San Diego, , Information Technology Recruiter San Francisco, Information Technology Recruitment Services San Francisco, Technical Recruiter San Francisco, Technical Recruitment Services San Francisco, Product Management Recruiter San Francisco, Product Management Recruitment Services San Francisco, C-Level Recruiter San Francisco, C-Level Recruitment Services San Francisco, Leadership Recruiters San Francisco, Leadership Recruitment Services San Francisco, Accounting Recruiter San Francisco, Accounting Recruitment Services San Francisco, Finance Recruiter San Francisco, Finance Recruitment Services San Francisco, Accounting & Finance Recruiter San Francisco, Accounting & Finance Recruitment Services San Francisco, Sales & Marketing Recruiter San Francisco, Sales & Marketing Recruitment Services San Francisco, Marketing Recruiter San Francisco, Marketing Recruitment Services San Francisco, Sales Recruitment San Francisco, Sales Recruitment Services San Francisco, Career Coaching Services San Francisco, Creatives Recruiter San Francisco, Creatives Recruitment Services San Francisco,'
          }
        }
      };
      const {formData} =this.state
		return (
      <div className="home-wrapper">
         <DocumentMeta {...meta}>
                <title>Right Connection - Contact Us</title>
                <meta property="og:title" content="MyApp" />
                <meta property="og:image" content="path/to/image.jpg" />
      		</DocumentMeta> 
        <Header/>
		      <div className="body-wrapper contactwallpapers">
		        <div className="container">
              <div className="row">
                <div className="col-lg-8 col-md-12 contact-box">
                <div className="row">
                {this.state.contaCtus &&
                  <div className="col-lg-7 col-md-6 ">
                      <h1 className="main-heading">Contact Us</h1>
                      <form onSubmit={this.contactUs} validate>
                      
                        <div className="form-group">
                          <label>Name</label>
                          <input type="text" id="name" name="name" className="form-control"  onChange={this.inputchange} placeholder="Name"  value={formData.name} />
                        </div>
                      
                        <div className="form-group">
                          <label>Email<span className="requiredFiled">*</span></label>
                          <input type="email" id="email" name="email" className="form-control"  onChange={this.inputchange} placeholder="Email"  value={formData.email} required/>
                        </div>
                      
                        <div className="form-group">
                          <label>Message</label>
                          <textarea rows="3" id="description" name="message"  onChange={this.inputchange} className="form-control" placeholder="Message" value={formData.message} ></textarea>
                        </div>
                        <div className={classCaptcha}>
                          <ReCAPTCHA sitekey="6LdxTa8UAAAAAFIF05saHBwoco8cbcPp-n-FkzAF" onChange={this.onChange}/>
                        </div>
                        <div className="form-group">  
                          <button type="submit" className="btn contact-submit-btn">Submit</button>
                        </div>
                     
                      </form>
                  </div>
                }
                {!this.state.contaCtus &&
                  <div className="col-lg-7 col-md-6" >
                  <div class="modal-confirm-contact modal-content">

                  <div class="icon-box">
                      <i class="fa fa-check"></i>
                  </div>
                  <div className="text-center textContactUs">
                      <h6>Thank you for contacting us</h6>
                      <p >
                        Your message has been successfully sent. We will contact you very soon!</p>
                        <a href="/" class="btn btn-success btn-block thanks-btn">Ok</a>
                    </div>
                  </div>
                 
                    </div>
                  }

                    {/*<div className="col-lg-4 col-md-6">
                      <address>
                        <h5>Customer service:</h5>
                        <ul className="contact-one">
                           <li><b>Phone:</b> +1 129 209 291</li>
                           <li><b>E-mail:</b> <a href="mailto:support@mysite.com">support@mysite.com</a></li>
                        </ul>

                        <h5>Headquarter:</h5>
                        <ul className="contact-one">
                           <li>Company Inc, <br />
                        Las vegas street 201<br />
                        55001 Nevada, USA<br /></li>
                           <li><b>Phone:</b> +1 145 000 101</li>
                           <li><b>E-mail:</b> <a href="mailto:usa@mysite.com">usa@mysite.com</a></li>
                        </ul>
                      </address>
                    </div>*/}
                    

                </div>
                  
                </div>
              </div>
            </div>
          </div>
        <Footer/>
        </div>
		    )
	}
} 
function mapStateToProps(state) {
  return {
    contactUsResponse:state.ContactUs.response
  }
}
export default withLocalize(withRouter(connect(mapStateToProps, {
  sendContactUsAction
} )(ContactUs)));



// WEBPACK FOOTER //
// ./src/components/Inc/InfoPage/ContactUs.js